export const SET_SOURCE = 'SET_SOURCE';

export const setSource = (source?: 'DDAI') => ({
  type: SET_SOURCE,
  payload: source,
});
